import { isCustomerDataIncomplete, selectBasket, selectBasketCustomer, selectBasketCustomerCompany, selectBasketCustomerValidation, selectBasketIsEmpty, updateCustomerData } from 'containers/OrderDetails/basketSlice'
import { COMPANY_FIELDS, USER_FIELDS, getVisibleSections, isPolishCountry, toFormValues } from './fields'
import SimplifiedSummary from 'containers/OrderDetails/Summary/SimplifiedSummary'
import IdentificationDataPopup from 'components/popups/IdentificationDataPopup'
import { useDispatch, useSelector } from 'react-redux'
import { resetForm, updateValues } from '../formSlice'
import { useEffect, useMemo, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'
import { STATUS } from 'utils/constants'
import { cartCustomer } from 'rest/urls'
import { POST } from 'rest/request'
import Form from './Form'
import '../style.scss'

const Contract = ({ isDesktop = false }) => {
  const { popup, openPopup } = usePopupState()
  const [status, setStatus] = useState(STATUS.idle)

  const { cartId, tenant, invoice } = useSelector(selectBasket)
  const customerValidation = useSelector(selectBasketCustomerValidation)
  const customerCompany = useSelector(selectBasketCustomerCompany)
  const customer = useSelector(selectBasketCustomer)
  const isBasketEmpty = useSelector(selectBasketIsEmpty)

  const dispatch = useDispatch()
  const { replace } = useHistory()
  const { t } = useTranslation('form')

  const isIncomplete = isCustomerDataIncomplete(customerValidation)
  const sections = useMemo(() => getVisibleSections(customerValidation), [customerValidation])

  useEffect(() => {
    if (isBasketEmpty) replace('/')
    else if (!isIncomplete) replace('/order/summary')
  }, [isBasketEmpty, isIncomplete, replace])

  useEffect(() => {
    const values = {
      ...toFormValues(customer, USER_FIELDS),
      ...toFormValues(customerCompany, COMPANY_FIELDS),
    }
    if (!values.cardType) delete values.cardType
    dispatch(resetForm())
    dispatch(updateValues(values))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => () => {
    dispatch(resetForm())
  }, [dispatch])

  const submit = async ({ customer, company }) => {
    setStatus(STATUS.pending)

    try {
      const body = { cartId }
      const companyId = customerCompany?.id || tenant?.company?.id || invoice?.id
      if (companyId) body.companyId = companyId
      if (customer) body.customer = customer
      if (company && companyId) body.company = company

      const response = await POST(cartCustomer, { body })
      dispatch(updateCustomerData(response))
      setStatus(STATUS.succeed)

    } catch (err) {
      setStatus(STATUS.failed)
      console.error(`Error: ${err}`)
    }
  }

  return (
    <>
      <div className='contract'>
        <div className='contract__title title'>
          <div>{t(sections.companyFields.length > 0 && !sections.userAddress && !sections.userIdentity && sections.userNames.length === 0 ? 'companyDetails' : 'userDetails')}</div>
          <div>{t('fillInMissingDetails')}</div>
        </div>

        {popup?.type === 'identificationData' && <IdentificationDataPopup />}

        <div className='contract__main main center'>
          {status === STATUS.pending && <Loading middleOfPage />}

          {isIncomplete && <Form
            block={status === STATUS.pending}
            sections={sections}
            validation={customerValidation}
            isPolish={isPolishCountry(customer?.country)}
            isCompanyPolish={isPolishCountry(customerCompany?.country)}
            submit={submit}
            showIdentificationPopup={() => {
              openPopup({ type: 'identificationData' })
            }} />}
        </div>
      </div>

      {isDesktop && !isBasketEmpty && <div className='orderInfo__aside'>
        <SimplifiedSummary />
      </div>}
    </>
  )
}

export default Contract
